import { NextSeo } from 'next-seo';
import React from 'react';
import PageHeader from '../../components/PageHeader';
import config from '../../config';
import TraitSwapPage from '../../components/TraitSwapPage';

function Page() {
  const title = `Trait Swapper - ${config.siteName}`;
  const description = `Swap traits between two of your Fourth Litter Shitty Kitties.`;

  return (
    <>
      <NextSeo title={title} description={description} />
      <div className='pb-12 md:pb-48 bg-bg'>
        <PageHeader
          heading={'Trait Swapper'}
          description={description}
          docsLink='https://docs.shittykitties.art/website-utilities/trait-swapper'
          fullWidth
        />

        <div className='px-4 lg:mx-auto lg:px-8'>
          <TraitSwapPage />
        </div>
      </div>
    </>
  );
}

export default Page;
